function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Tick_svg__a{fill:none;stroke:#22c69d;stroke-linecap:round;stroke-linejoin:round}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1125.5 -707.227)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "Tick_svg__a",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(1126 707.727)"
}), /*#__PURE__*/React.createElement("path", {
  className: "Tick_svg__a",
  d: "M1137.367 713.578l-3.807 5.076a.986.986 0 01-1.482.106l-1.966-1.966"
}));

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:none;stroke:%2322c69d;stroke-linecap:round;stroke-linejoin:round%7D%3C/style%3E%3C/defs%3E%3Cg transform='translate(-1125.5 -707.227)'%3E%3Ccircle class='a' cx='8' cy='8' r='8' transform='translate(1126 707.727)'/%3E%3Cpath class='a' d='M1137.367 713.578l-3.807 5.076a.986.986 0 01-1.482.106l-1.966-1.966'/%3E%3C/g%3E%3C/svg%3E";
export { SvgTick as ReactComponent };